module.exports = {
	"root": "findify-components--powered-by"
};